import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({

  geneticEvaluationExportButtonContainer: {
    padding: '16px 0'
  },

  geneticEvaluationContent: {
    marginTop: 16,
  },

  geneticEvaluationButtonExport: {
    width: 'max-content',
    display: 'flex',
    padding: '8px 16px 8px 12px',
    gap: '8px',
    textTransform: 'uppercase',

    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    }
  }



}))
